import { useZipRootLoaderData } from "../../hooks/useZipRootLoaderData";
import { IPlans } from "../../interfaces/api";
import BackHeaderCoverage from "../GetRecommendations/CoverageYear/BackHeaderCoverage.component";
import { Link, useRevalidator } from "react-router-dom";

const AllPlansHeader = ({ plans }: { plans: IPlans }) => {
  const revalidator = useRevalidator();
  const { selectedYear, yearsForZip } = useZipRootLoaderData();

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedYear = parseInt(event.target.value, 10);
    sessionStorage.setItem("planYear", selectedYear.toString());
    sessionStorage.removeItem("dataArray");
    revalidator.revalidate();
  };

  return (
    <>
      <BackHeaderCoverage
        plansLength={plans.Plans.length}
        planData={plans.Plans[0]}
        showLink={true}
      />
      <div
        className="grid-container"
        style={{ paddingTop: 22, paddingBottom: 33 }}
      >
        <div className="grid-x align-center text-center margin-0">
          <h3
            className="cell blue-stroke text-center"
            style={{ fontWeight: 600 }}
          >
            {plans.Plans.length} Plans in your area
          </h3>
          <div
            className="flex-container align-middle"
            style={{
              width: "100%",
              justifyContent: "center",
              paddingBottom: "24px",
              paddingTop: "20px",
              gap: "8px",
            }}
          >
            <div className="text-right align-middle">Viewing plans for</div>
            <div className="text-left">
              <select
                style={{
                  width: "150px",
                  padding: "14px 16px",
                  cursor: "pointer",
                }}
                onChange={handleSelectChange}
                value={selectedYear}
              >
                {yearsForZip.map((year, index) => (
                  <option key={index} value={year.Year}>
                    {year.Year}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div>
            <div>
              Can't decide on a plan?{" "}
              <Link
                to={{ pathname: "/get-recommendations/coverage-year" }}
                className="primary-color"
                style={{ textDecoration: "underline" }}
              >
                Let us help you choose.
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllPlansHeader;
